import { Config } from '../../config'

export const labrepcoConfig: Config = {
  partner: 'labrepco',
  catalog: 'partner',
  displayName: 'LabRepCo',
  accentColor: '#486ca9',
  host: 'seating.labrepco.com',
}

